export const RoleBreadcrumb = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Roles", path: "/roles" },
];
